import { useTheme } from "@mui/material";
import MUITooltip, { TooltipProps } from "@mui/material/Tooltip";

const Tooltip = ({ arrow = true, sx, ...props }: TooltipProps) => {
  const theme = useTheme();
  const styles = {
    tooltip: {
      "& .MuiTooltip-tooltip": {
        backgroundColor: theme?.palette?.surface80?.main || "#E6E7ED",
        color: theme?.palette?.surface10?.main || "#191C2E",
      },
      "& .MuiTooltip-arrow:before": {
        backgroundColor: theme?.palette?.surface80?.main || "#E6E7ED",
      },
      ...sx,
    },
  };

  return (
    <MUITooltip
      arrow={arrow}
      componentsProps={{
        popper: {
          sx: styles.tooltip,
        },
      }}
      {...props}
    />
  );
};

export default Tooltip;
